<script setup lang="ts">
import { useClassStore, useUserStore } from '../../stores';
import { ClassViewMode } from '../../types/class';
import Management from '../../assets/icons/book-open.svg'
import Teaching from '../../assets/icons/chalkboard.svg'

import Button from '../General/Button.vue';
import { computed } from 'vue';
import { UserRole } from '../../types/user';

const classStore = useClassStore()
const user = useUserStore()

const handleChangeViewMode = (viewMode: ClassViewMode) => {
    classStore.viewMode = viewMode
}
const hasRequest = computed(() => {
    return user.userRole === UserRole.teacher && classStore.requestedStudentIds.length && classStore.selectedClassDetails
})

// const hasRaiseHandStudents = computed(() => {
//     return user.userRole === UserRole.teacher && classStore.raiseHandStudentIds.length && classStore.selectedClassDetails
// })

const iconMap = {
    [ClassViewMode.management]: Management,
    [ClassViewMode.teaching]: Teaching,
}
</script>

<template>
    <div class="flex items-center">
        <Button class="relative" v-for="viewMode in ClassViewMode" :color="viewMode === classStore.viewMode ? 'success' : 'gray'" :design="viewMode === ClassViewMode.management ? 'rounded-s' : 'rounded-e'" @click="handleChangeViewMode(viewMode)">
            <component :is="iconMap[viewMode]" class="size-5" />
            <i v-if="(hasRequest && viewMode === ClassViewMode.management)"
                class="absolute top-2 right-3 size-2 rounded-full bg-red-500 before:absolute before:size-2 before:rounded-full before:bg-red-500 before:top-0 before:left-0 before:animate-ping"></i>
        </Button>
    </div>
</template>